(function(){'use strict';
if (!window.theme || !theme.buildProductImage) return;
var originalBuild = theme.buildProductImage;
theme.buildProductImage = function(product,imageSizes) {
    // Packages have no synthetic product photo: show their verified original components.
    if (!product.featured_image) {
      var packageMapNode = document.getElementById('pb-package-card-map');
      if (packageMapNode) {
        var packageMap = JSON.parse(packageMapNode.textContent);
        var packageVariants = packageMap[String(product.id)];
        if (packageVariants) {
          var selectedPackageVariant = new URL(product.url, location.origin).searchParams.get('variant');
          var components = packageVariants[selectedPackageVariant] || Object.values(packageVariants)[0];
          var photos = document.createElement('div');
          photos.className = 'pb-package-card-photos';
          components.forEach(function(component) {
            var photo = document.createElement('img');
            photo.src = component.image;
            photo.alt = component.quantity + ' × ' + component.name;
            photo.width = 360;
            photo.height = 360;
            photo.loading = 'lazy';
            photos.appendChild(photo);
          });
          return photos.outerHTML;
        }
      }
    }
return originalBuild.call(this,product,imageSizes);
};
})();
